import { Breadcrumb, Paginator, Table, TitleScreen, Tooltip } from "components/Core"
import ButtonListNavigation from "components/ButtonListNavigation"
import SearchBarFilter from "components/SearchBarFilter"
import { get_data_table_coverages } from "helpers/data_tables"
import usePaginationTable from "hooks/usePaginationTable"
import { useEffect, useState } from "react"
import { LuPencil } from "react-icons/lu"
import useFiltersTable from "hooks/useFiltersTable"
import { parsed_filters_on_search } from "helpers/data_tables"
import useCombinedCoverageBFF from "hooks/bff_entities/useCombinedCoverageBFF"

const ListScreen = () => {
  const [data, set_data] = useState<any>({})
  const { loading_app, post_advance_search_combined_coverages_action } = useCombinedCoverageBFF()
  const { current_data, current_page, handle_page_change, handle_per_page, per_page, total_records, total_pages } =
    usePaginationTable({
      data,
    })

  const { filters_table } = useFiltersTable({ table_name: "coverages", onFilterApplied: () => handle_page_change(0) })

  useEffect(() => {
    const call = async () => {
      let res: any = await post_advance_search_combined_coverages_action({
        body: {
          skipRecords: per_page * current_page,
          maxRecords: per_page,
          filter: parsed_filters_on_search(filters_table.state),
        },
      })
      if (res?.records?.length > 0) {
        set_data({ records: res.records, pages: res?.maxPages, total: res?.totalRecordsMatched })
      } else {
        set_data({ records: [], pages: 0, total: 0 })
      }
    }
    call()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current_page, per_page, filters_table.state])

  const [columns, data_table_coverages] = get_data_table_coverages(current_data)

  return (
    <div className="w-full h-full flex flex-col items-center justify-start">
      <Breadcrumb data={[{ name: "Listado de coberturas", href: "/coverages" }]} />
      <div className="w-full flex flex-col justify-center items-center py-4 px-6">
        <TitleScreen title="listado de coberturas" />
        {/* <p>CoveragesListScreen</p> */}
      </div>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full flex flex-col lg:flex-row justify-between items-end lg:items-center gap-4 px-6">
          <SearchBarFilter handle_page_change={handle_page_change} />
          <ButtonListNavigation label="Crear Cobertura" route="/coverages/new" />
        </div>
        <div className="w-full flex flex-col gap-2 px-6">
          <Paginator
            current_page={current_page}
            handle_page_change={handle_page_change}
            per_page={per_page}
            total_records={total_records}
            total_pages={total_pages}
            handle_per_page={handle_per_page}
          />
          <div className="w-full overflow-x-auto">
            <Table>
              <Table.Head>
                <Table.HeadCell className="!w-5">
                  <></>
                </Table.HeadCell>
                {columns?.map((key: string) => (
                  <Table.HeadCell key={key}>{key}</Table.HeadCell>
                ))}
              </Table.Head>
              <Table.Body>
                {!loading_app && data_table_coverages?.length ? (
                  data_table_coverages?.map((coverage: any, i: number) => (
                    <Table.Row key={i}>
                      <Table.Cell className="flex flex-row items-center justify-end gap-2">
                        <Tooltip content="Editar" align="top">
                          <a href={`/coverages/${coverage?.id}/edit`}>
                            <LuPencil className="pencil_edit opacity-0 text-lg cursor-pointer" />
                          </a>
                        </Tooltip>
                      </Table.Cell>
                      {Object.values(coverage)?.map((value: any, i: number) =>
                        i === 0 ? (
                          <Table.Cell key={i} mainCol>
                            <a href={`/coverages/${value}`} className="text-[#F9004D] underline">
                              {value}
                            </a>
                          </Table.Cell>
                        ) : (
                          <Table.Cell key={i}>{value}</Table.Cell>
                        ),
                      )}
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell>{loading_app ? "Espere..." : "Sin resultados"}</Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListScreen
